import FreshFishhome from "./HomePage/FreshFish";
import PreviousOrders from "./HomePage/PreviousOrders";
import BestPicks from "./HomePage/BestPicks";
import DryFishhome from "./HomePage/DryFishhome";
import EditProfile from "./Profile/EditProfile";
import YourOrders from "./Profile/YourOrders";
import SavedAddress from "./Profile/SavedAddress";
import MapHelp from "./Profile/MapHelp";
import AboutUs from "./Profile/AboutUs";
import ContactUs from "./Profile/ContactUs";
import RemoveAccount from "./Profile/RemoveAccount";
import LogOut from "./Profile/LogOut";
import SuccesModal from "./SuccesModal/SuccesModal";
import confirmModal from "./confirmModal/confirmModal";
import ErrorModal from "./ErrorModal/ErrorModal";
import ProductCategory from "./Food/ProductCategory/ProductCategory";
import RestaurantsList from "./Food/RestaurantsList/RestaurantsList";
import RestaurantProduct from "./Food/RestaurantProduct/RestaurantProduct";
import RestaurantCategory from "./Food/RestaurantCategory/RestaurantCategory";
import Payment from "./payment/payment";
import FoodSpecialOffers from "./Food/FoodSpecialOffers/FoodSpecialOffers";
import ProductSearchListing from "./Food/productSearchListing/productSearchListing";
import RecommendedGroceryProducts from "./recommendedProducts/recommendedGroceryProducts";
import Favourites from "./HomePage/favourites/favourites";
export {
  FreshFishhome,
  PreviousOrders,
  DryFishhome,
  BestPicks,
  EditProfile,
  YourOrders,
  SavedAddress,
  MapHelp,
  AboutUs,
  ContactUs,
  RemoveAccount,
  LogOut,
  SuccesModal,
  ErrorModal,
  ProductCategory,
  RestaurantsList,
  RestaurantProduct,
  RestaurantCategory,
  Payment,
  FoodSpecialOffers,
  confirmModal,
  ProductSearchListing,
  RecommendedGroceryProducts,
  Favourites,
};
